import { render, staticRenderFns } from "./needs-parent-item.html?vue&type=template&id=13e7db42&"
import script from "./needs-parent-item.js?vue&type=script&lang=js&"
export * from "./needs-parent-item.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports